import React, { useState, useEffect, useContext } from "react";
import "../App.css";
import { useHistory } from "react-router-dom";
import Api from "./api/api";
import MyStorage from "./util/storage";
import { AuthContext } from "../context/AuthContext";

const Dashboard = () => {
  const history = useHistory();
  const {user, setUser} = useContext(AuthContext);
  const [users, setUsers] = useState("0");
  const [subscriptions, setSubscriptions] = useState("0");
  const [joined, setJoined] = useState("0");
  const [sales, setSales] = useState("0");

  const [subRecords, setSubRecords] = useState([]);
  const [joinedRecords, setJoinedRecords] = useState([]);
  const [salesRecords, setSalesRecords] = useState([]);

  // load data
  useEffect(() => {
    loadData();
    loadFileUrls(); // cache
  }, []);

  const loadData = () => {
    Api.getDashboardData(
      (response) => {
        setUsers(response.user);
        setSubscriptions(response.subs);
        setJoined(response.joined);
        setSales(response.sales);
        setSubRecords(response.subs_records);
        setJoinedRecords(response.joined_records);
        setSalesRecords(response.sales_records);
        if (response.msg) {
          if (response.msg.includes("Invalid")) {
            logoutUser();
          }
        }
      },
      (error) => {}
    );
  };

  const logoutUser = () => {
    console.log("logoutUser");
    Api.logoutUser(
      user.id,
      (response) => {
        setUser(null);
        history.push("/login");
      },
      (error) => {
        //
      }
    );
    setUser(null);
    setUsers("0"); // just to refresh the screen for login redirect
  };

  const loadFileUrls = () => {
    Api.getFileUrls(
      (response) => {
        MyStorage.setFileUrls(response);
      },
      (error) => {
        //
      }
    );
  };

  // check session
  // if (!MyStorage.isLogin()) {
  //     console.log('logged out');
  //     let url = window.location.href
  //     console.log('url: ' + url);
  //     if (url.includes('?program=')) {
  //         console.log('DOWNLOAD');
  //         return <Redirect to='/download' />;
  //     }
  //     else {
  //         console.log('LOGIN');
  //         return <Redirect to='/login' />;
  //     }
  // }

  return (
    <div
      className="main"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ display: "flex", marginTop: -50 }}>
        <div
          style={{
            width: 300,
            height: 150,
            backgroundColor: "green",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => {
            console.log("click");
            history.push("/users");
          }}
        >
          <div style={{ fontSize: 16, color: "white" }}>Total Users</div>
          <div style={{ fontSize: 50, fontWeight: "bold", color: "white" }}>{users}</div>
        </div>

        <div
          style={{
            marginLeft: 30,
            width: 300,
            height: 150,
            backgroundColor: "orange",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => {
            console.log("click");
            history.push({
              pathname: "/home-subscriptions",
              state: { users: subRecords },
            });
          }}
        >
          <div style={{ fontSize: 16, color: "white" }}>Subscriptions</div>
          <div style={{ fontSize: 50, fontWeight: "bold", color: "white" }}>{subscriptions}</div>
        </div>
      </div>
      <div style={{ display: "flex", marginTop: 30 }}>
        <div
          style={{
            width: 300,
            height: 150,
            backgroundColor: "purple",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => {
            console.log("click");
            history.push({
              pathname: "/home-programs-joined",
              state: { programs: joinedRecords },
            });
          }}
        >
          <div style={{ fontSize: 16, color: "white" }}>Programs Joined</div>
          <div style={{ fontSize: 50, fontWeight: "bold", color: "white" }}>{joined}</div>
        </div>
        <div
          style={{
            marginLeft: 30,
            width: 300,
            height: 150,
            backgroundColor: "blue",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => {
            console.log("click");
            history.push({
              pathname: "/home-program-sales",
              state: { programs: salesRecords },
            });
          }}
        >
          <div style={{ fontSize: 16, color: "white" }}>Program Sales</div>
          <div style={{ fontSize: 50, fontWeight: "bold", color: "white" }}>{sales}</div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
